import axios from 'axios'
import router from '../router/index'
import {getToken} from "./auth";
import {removeToken} from './auth';
import {Message} from 'element-ui'
import Vue from "vue";

const service = axios.create({
  baseURL: '',
  timeout: 1000000, // request timeout
})

service.interceptors.request.use(
  config => {
    let url = config.url,
      token = getToken();
    if (url.indexOf("http") < 0) {
      if (url.indexOf("/") !==0) {
        url = Vue.prototype.$api + `/`+url
      } else {
        url = Vue.prototype.$api + url
      }
    }
    if (token && url.indexOf('token') < 0) {
      if (url.indexOf('?') < 0) {
        url = url + `?token=${token}`;
      } else {
        url = url + `&token=${token}`;
      }
    }
    config.url = url;

    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.headers["content-type"].indexOf("json") !== -1) {
      if (response.status == 200) {
        if (response.data.code == 18) {
          removeToken();
          router.push({path: '/login'})
          return
        }
        response.data.code = parseInt(response.data.code, 10)
        if (parseInt(response.data.code) != 0) {
          Message.error(response.data.msg)
          return Promise.reject()
        }
      }
      return response.data
    }
    return response

  },
  error => {
    console.log('err' + error)
    Message.error('网络异常')
    return Promise.reject(error)
  }
)

export default service
